export * from "./discount";
export * from "./offer";
export * from "./transaction";
export * from "./venue";

export enum LoyaltyService {
  Como = "como",
  Tickit = "tickit",
  Rotana = "rotana",
  Qlub = "qlub",
  GHA = "gha"
}
